import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=98626126&scoped=true&lang=html"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterForm.css?vue&type=style&index=0&id=98626126&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98626126",
  null
  
)

export default component.exports